import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';

const styles = require('./OptionsPaneError.scss');

export default class OptionsPaneError extends React.Component<{}, {}> {
    render() {
        return (
            <div className={styles.messageContainer}>
                <div className={strings.optionsFull_subCategory_error} />
            </div>
        );
    }
}
